<template>
	<div class="jmhome">

		<div class="nr">
			<div class="left">
				<div class="top">
					<div class="bt">
						<img class="bt-img" src="../../../../../static/img/comm/home.png" />
						<div>{{paiming.title}}</div>
					</div>
					<paiming :items="paiming.items"></paiming>
				</div>
				<div class="down">
					<div class="bt">
						<img class="bt-img" src="../../../../../static/img/comm/home.png" />
						<div>{{bzt.title}}</div>
					</div>
					<bingzhuangtu :data1="bzt.data1" :name='bzt.name' :data2='bzt.data2'></bingzhuangtu>
				</div>
			</div>
			<div class="centre">
				<div class="top">
					<div class="bt">
						<img class="bt-img" src="../../../../../static/img/comm/home.png" />
						<div>{{zexiantu.title}}</div>
					</div>
					<zexiantu :data1='zexiantu.data1' :data2="zexiantu.data2" :date="zexiantu.date"  minWidth="500px"></zexiantu>
				</div>
				<div class="down">
					<div class="bt">
						<img class="bt-img" src="../../../../../static/img/comm/home.png" />
						<div>点位分布</div>
					</div>
					<ditu v-if="hackResetditu" :zxd="zxd" :qt="qt" :h="h" :zoom="zoom"></ditu>
				</div>
			</div>
			<div class="right">
				<yuanhuan v-for="item in yhs" :key="item.id" :yh='item'></yuanhuan>
			</div>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import zexiantu from '@/components/comm/home/zexiantu.vue'
	import paiming from '@/components/comm/home/paiming.vue'
	import bingzhuangtu from '@/components/comm/home/bingzhuangtu.vue'
	import ditu from '@/components/comm/ditu/ditu.vue'
	export default {

		data() {
			return {
				//地图
				h:"400px",
				zoom:2,
				zxd: [106.49275526969987, 29.61166095192132], //中心点坐标
				qt: [
					 {position: [121.5263285, 31.21415044],id:1,url:'alliance/mac/aisle/list',address:'测试地址',code:'s-12'},
					{position: [121.5273285, 31.29415044],id:1,url:'alliance/mac/aisle/list',address:'测试地址',code:'s-12'}
				],
				hackResetditu:true,
				//地图
				bzt: {
					title:'广告类型',
					data1: ['百货', '药品', '家电', '服装', '其他'],
					name: '广告分类',
					data2: [{
							value: 335,
							name: '百货'
						},
						{
							value: 310,
							name: '药品'
						},
						{
							value: 234,
							name: '家电'
						},
						{
							value: 135,
							name: '服装'
						},
						{
							value: 1048,
							name: '其他'
						}
					]
				},
				paiming:{
					title:'今日新增广告投放商排名',
					items:[
						{id:1,type:'error',pm:'TOP1',address:'重庆市渝北区',bfb:100,sl:100},
						{id:2,type:'warning',pm:'TOP2',address:'重庆市江北区',bfb:60,sl:60},
						{id:3,type:'primary',pm:'TOP3',address:'重庆市潼南区',bfb:50,sl:50},
						{id:4,type:'info',pm:'TOP4',address:'重庆市万州区',bfb:40,sl:40},
						{id:5,type:'info',pm:'TOP5',address:'重庆市璧山区',bfb:10,sl:10}
					]
				},
				zexiantu:{
					title:'数据统计',
					data1:['广告投放商数量', '订单数', '销售额'],
					data2: [{
							name: '广告投放商数量',
							type: 'line',
							stack: '总量',
							data: [120, 132, 101, 134, 90, 230, 210]
						},
						{
							name: '订单数',
							type: 'line',
							stack: '总量',
							data: [220, 182, 191, 234, 290, 330, 310]
						},
						{
							name: '销售额',
							type: 'line',
							stack: '总量',
							data: [150, 232, 201, 154, 190, 330, 410]
						}
					],
					date:["1","2","3","4","5","6","7"]
				}
			}
		},
		components: {
			zexiantu,
			paiming,
			bingzhuangtu,
			ditu
		},
		methods:{
			dihuizhiditu(){
				console.log(a)
				let _this=this
				for (var i = 0; i < a.length; i++) {
					let latitude = parseFloat(a[i].latitude)
					let longitude = parseFloat(a[i].longitude)
					let b = {
						position: [longitude, latitude],
						id: a[i].id,
						url: '/main/jm/platform/allianceMacAisle/list',
						address: a[i].address,
						code: a[i].macCode,
					}
					//_this.qt.push(b)
				}
				//重新渲染子组件
				 this.hackResetditu = false
				this.$nextTick(() => {
					this.hackResetditu = true
				}) 
			}
		},
		created() {

		}

	}
</script>
<style scoped lang="less">
	.jmhome {
		display: flex;
		flex-direction: column;
	}


	.nr {
		display: flex;

		.left {
			.top {
				padding: 5px;

				.bt {
					display: flex;
					align-items: center;

					.bt-img {
						width: 50px;
						height: 50px;
						margin-right: 20px;
					}
				}
			}

			.down {
				padding: 5px;

				.bt {
					display: flex;
					align-items: center;

					.bt-img {
						width: 50px;
						height: 50px;
						margin-right: 20px;
					}
				}
			}
		}

		.centre {
			

			.top {
				padding: 5px;

				.bt {
					display: flex;
					align-items: center;

					.bt-img {
						width: 50px;
						height: 50px;
						margin-right: 20px;
					}
				}
			}

			.down {
				padding: 5px 5px 0px 5px;

				.bt {
					display: flex;
					align-items: center;

					.bt-img {
						width: 50px;
						height: 50px;
						margin-right: 20px;
					}
				}
			}
		}

		.right {}

	}
</style>



// WEBPACK FOOTER //
// src/components/home/jm/platform/guanggaotongji.vue